<template>
  <div class="form-outer-group">
    <div class="form-group" :class="`${styleClass.parentElement} ${wrapClass}`">
      <label :class="`${styleClass.label} ${labelClass}`" :for="inputId">
        <slot>Label</slot>
      </label>
      <div :class="`${styleClass.input} ${inputClass} position-relative`">
        <input
          :type="checkInputType"
          class="form-control"
          :id="inputId"
          :value="modelValue"
          :step="control == 'number' && step"
          :min="control == 'number' && min"
          autocomplete="off"
          :required="required"
          :placeholder="placeholder"
          :disabled="disabled"
          :autofocus="autofocus"
          :maxlength="maxLength"
          @input="update($event.target.value)"
          v-cleave="cleave"
          v-if="
            [
              'text',
              'password',
              'radio',
              'checkbox',
              'email',
              'number',
            ].includes(control)
          "
        />

        <span
          v-if="control === 'password' && showPasswordToggle"
          :style="showPasswordIconStyle"
          class="password-eye"
          @click="isPasswordShown = !isPasswordShown"
        >
          <i :class="isPasswordShown ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </span>

        <textarea
          :class="`form-control ${textareaClass}`"
          :id="inputId"
          :value="modelValue"
          v-if="control == 'textarea'"
          autocomplete="off"
          :required="required"
          :placeholder="placeholder"
          :autofocus="autofocus"
          :maxlength="maxLength"
          :disabled="disabled"
          :readonly="readonly"
          @input="update($event.target.value)"
          v-autosize
        ></textarea>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InputControl",
  props: {
    modelValue: [String, Number, Boolean],
    type: {
      type: String,
      default: "stacked",
    },
    placeholder: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    control: {
      type: String,
      default: "text",
    },
    step: String,
    min: String,
    cleave: {
      type: Object,
      default: null,
    },
    maxLength: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    wrapClass: {
      type: String,
      default: "",
    },
    labelClass: {
      type: String,
      default: "",
    },
    inputClass: {
      type: String,
      default: "",
    },
    textareaClass: {
      type: String,
      default: "",
    },
    showPasswordToggle: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    inputId: function () {
      let id = (((this.$slots.default || [])[0] || {}).text || "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/gi, "-");
      return `input-control-${id}`;
    },
    checkInputType() {
      if (this.control !== "password") return this.control;
      return this.isPasswordShown ? "text" : "password";
    },
    showPasswordIconStyle() {
      if (this.type == "horizontal") {
        return {
          right: "22px",
        };
      }
      return {
        right: "12px",
      };
    },
  },
  data() {
    return {
      styleClass: {
        parentElement: "",
        label: "",
        input: "",
      },
      isPasswordShown: false,
      fieldType: "text",
    };
  },
  mounted() {
    if (this.type == "horizontal") {
      this.styleClass.parentElement = "row";
      this.styleClass.label = "col-md-2 col-form-label";
      this.styleClass.input = "col";
    }
  },

  methods: {
    update: function (value) {
      this.$emit("update:modelValue", value);
    },
  },
};
</script>

<style lang="css" scoped>
.password-eye {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d;
  z-index: 2;
}

.password-eye:hover {
  color: #000;
}
</style>
